<script>
import { mapGetters } from 'vuex';
import LongFormModalRow from './LongFormModalRow.vue';
export default {
  name: 'EventSelectionModalLongForm',
  components: {
    LongFormModalRow,
  },
  props: {
    competitorId: {
      type: String,
      required: true,
    },
    records: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      expandAll: false,
    };
  },
  computed: {
    ...mapGetters({
      selectionModalData: 'FormGuideEventCard/getSelectionModalData',
    }),
  },
  methods: {
    toggleExpandAll() {
      this.expandAll = !this.expandAll;
    },
  },
};
</script>

<template>
  <div class="event-select-modal-lf">
    <div class="event-select-modal-lf__header">
      <div class="event-select-modal-lf__header-text">LONG FORM</div>
      <div class="event-select-modal-lf__header-right">
        <a
          :class="[{ active: expandAll }]"
          class="event-select-modal-lf__btn"
          href="#"
          @click.prevent="toggleExpandAll"
        >
          <p>Expand All</p>
        </a>
      </div>
    </div>

    <template v-for="(record, index) in records">
      <LongFormModalRow
        :key="`long-form-${index}-${expandAll}`"
        :competitor-id="competitorId"
        :record="record"
        :expand-all="expandAll"
      />
    </template>
  </div>
</template>
